<fury-page-layout mode="card" class="full_body">
    <fury-page-layout-header class="top_heading">
        <fury-breadcrumbs [crumbs]="['Calrail Lead']" current="Callrail Lead details"></fury-breadcrumbs>
        <button mat-button class="can-button" (click)="back()"><mat-icon>keyboard_backspace</mat-icon> Back</button>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>

        <div class="detail_body">
            <mat-tab-group animationDuration="0ms">
                <mat-tab label="Personal Information">
                        <div class="details_box">
                                <ul>
                                    <li>
                                        <label>
                                            First Name
                                        </label>
                                        <p>
                                          {{callRailLead?.firstName}}
                                        </p>
                                    </li>
                                    <li>
                                        <label>
                                            Last Name
                                        </label>
                                        <p>
                                            {{callRailLead?.lastName}}
                                        </p>
                                    </li>
                                    <li>
                                        <label>
                                            Email Address
                                        </label>
                                        <p>
                                            {{callRailLead?.emailAddress}}
                                        </p>
                                    </li>
                    
                                    <li>
                                        <label>
                                           Sec. Email Address
                                        </label>
                                        <p>
                                            {{callRailLead?.secondaryEmailAddress}}
                                        </p>
                                    </li>
                                    <li>
                                        <label>
                                            Mobile No
                                        </label>
                                        <p>
                                            {{callRailLead?.mobileNumber | mask : "(000) 000-0000"}}
                                        </p>
                                    </li>
                    
                                    <li>
                                        <label>
                                            Sec. Mobile No
                                        </label>
                                        <p>
                                            {{callRailLead?.secondaryMobileNumber | mask : "(000) 000-0000"}}
                                        </p>
                                    </li>

                                    <li>
                                        <label>
                                        Business Phone No
                                        </label>
                                        <p>
                                            {{callRailLead?.businessPhoneNumber | mask : "(000) 000-0000"}}
                                        </p>
                                    </li>
                    
                                    <li>
                                        <label>
                                            Address
                                        </label>
                                        <p>
                                            {{callRailLead?.propertyAddress?.streetAddress}}
                                        </p>
                                    </li>
                                    <li>
                                        <label>
                                            City
                                        </label>
                                        <p>
                                            {{callRailLead?.propertyAddress?.city}}
                                        </p>
                                    </li>
                                    <li>
                                        <label>
                                            State
                                        </label>
                                        <p>
                                            {{callRailLead?.propertyAddress?.state}}
                                        </p>
                                    </li>
                                    <li>
                                        <label>
                                            Zip Code
                                        </label>
                                        <p>
                                            {{callRailLead?.streetAddress?.zip}}
                                        </p>
                                    </li>
                                </ul>
                        </div>
                </mat-tab>
                <mat-tab label="Lead details">
                    <div class="details_box">
                        <ul>
                            <li>
                                <label>
                                    Added On
                                </label>
                                <p>
                                    {{commonService.convertDate(callRailLead?.createdAt) | date : 'MMM-dd-YYYY h:mm a'}}
                                </p>
                            </li>
                            <li>
                                <label>
                                   Utm Source
                                </label>
                                <p>
                                    {{callRailLead?.utmSource}}
                                </p>
                            </li>
                            <li>
                                <label>
                                   Lead Source
                                </label>
                                <p>
                                    {{callRailLead?.leadSource}}
                                </p>
                            </li>
                            <li>
                                <label>
                                    Result Code
                                </label>
                                <p>
                                    {{callRailLead?.vanillaSoftData?.ResultCode}}
                                </p>
                            </li>
                            
                            <li>
                                <label>
                                    Ip Address
                                </label>
                                <p>
                                    {{callRailLead?.ipAddress}}
                                </p>
                            </li>
                            <li>
                                <label>
                                    Tracking Number
                                </label>
                                <p>
                                    {{callRailLead?.trackingNumber | mask : "(000) 000-0000"}}
                                </p>
                            </li>

                            
                            <li>
                                <label>
                                    Duration
                                </label>
                                <p>
                                    {{callRailLead?.duration}}
                                </p>
                            </li>
            
                            <li>
                                <label>
                                    Phone Status
                                </label>
                                <p>
                                    {{callRailLead?.phoneStatus === "1" ? 'True': 'False'}}
                                </p>
                            </li>
                            <li>
                                <label>
                                    Lead Status
                                </label>
                                <p>
                                    {{callRailLead?.vanillaSoftData?.leadStatus}}
                                </p>
                            </li>
                            <li>
                                <label>
                                    Sold Amount
                                </label>
                                <p>
                                    {{(callRailLead?.soldAmount || 0) | currency}}
                                </p>
                            </li>
            
                            <li>
                                <label>
                                    Result Count
                                </label>
                                <p>
                                    {{callRailLead?.vanillaSoftData?.resultCount}}
                                </p>
                            </li>
            
                            <li>
                                <label>
                                    Vanilla Soft Status
                                </label>
                                <p>
                                    {{callRailLead?.isPostedToVanillaSoft ? "Sent" :"Not Sent"}}
                                </p>
                            </li>
                            <li class="large-text">
                                <label>
                                     Sub Id
                                </label>
                                <p>
                                    {{callRailLead?.subId}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                     Click Id
                                </label>
                                <p>
                                    {{callRailLead?.clickId}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Facebook Click Id
                                </label>
                                <p>
                                    {{callRailLead?.fbclid}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Google Click Id
                                </label>
                                <p>
                                    {{callRailLead?.gclid}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Microsoft Click Id
                                </label>
                                <p>
                                    {{callRailLead?.msclkid}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Twitter Click Id
                                </label>
                                <p>
                                    {{callRailLead?.twclid}}
                                </p>
                            </li>
            
            
                            <li class="large-text">
                                <label>
                                    Internal Url
                                </label>
                                <p>
                                    {{callRailLead?.internalUrl}}
                                </p>
                            </li>
            
            
                            <li class="large-text">
                                <label>
                                   Keywords
                                </label>
                                <p>
                                    {{callRailLead?.keyword}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Traffic Type
                                </label>
                                <p>
                                    {{callRailLead?.trafficType}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Position
                                </label>
                                <p>
                                    {{callRailLead?.position}}
                                </p>
                            </li>
            
                            <li class="large-text">
                                <label>
                                    Referral Domain
                                </label>
                                <p>
                                    {{callRailLead?.referalDomain}}
                                </p>
                            </li>
                        </ul>
                    </div>
                    
                </mat-tab>
            </mat-tab-group>
        </div>


    </fury-page-layout-content>
</fury-page-layout>